<footer>
   <div class="copyWrite">
      &copy;2022  SNJNR All copy Writes Reserved
   </div>
</footer>

<style>
    footer
    {
       margin : 80px auto;
       width: 100%;
       padding: 0px;
       text-align: center;
    }
    .copyWrite
    {
        font-size: 25px;
        border-bottom: 1px solid black;
    }

</style>